module.exports = __webpack_public_path__ + "static/media/ScheduleColored.c9fbd30e.png";